import React from 'react';
import { useLocation } from 'react-router-dom';

export const Location = Component => {
  const Wrapper = props => {
    const location = useLocation();

    return <Component location={location} {...props} />;
  };

  return Wrapper;
};
